import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Plus } from 'lucide-react';
import { AVAILABLE_VARIABLES } from '@/constants/reminderTemplates';

interface VariableInserterProps {
  onInsert: (variable: string) => void;
  disabled?: boolean;
}

export function VariableInserter({ onInsert, disabled = false }: VariableInserterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled}>
          <Plus className="h-4 w-4 mr-2" />
          Insert Variable
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        {AVAILABLE_VARIABLES.map((category, categoryIndex) => (
          <div key={category.category}>
            <DropdownMenuLabel className="text-xs font-medium text-muted-foreground">
              {category.category}
            </DropdownMenuLabel>
            {category.variables.map((variable) => (
              <DropdownMenuItem
                key={variable.key}
                onClick={() => onInsert(variable.key)}
                className="flex flex-col items-start py-2"
              >
                <div className="font-mono text-sm">{variable.key}</div>
                <div className="text-xs text-muted-foreground">{variable.description}</div>
              </DropdownMenuItem>
            ))}
            {categoryIndex < AVAILABLE_VARIABLES.length - 1 && <DropdownMenuSeparator />}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 